import { Routes, provideRouter, withRouterConfig } from '@angular/router';
import { EmployeesComponent } from './pages/employees/employees.component';
import { AddEmployeeComponent } from './pages/add-employee/add-employee.component';

import { LoginComponent } from './pages/login/login.component';
import { AuthGuard } from './core/guards/auth.guard';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { CurrencyAdjustmentsComponent } from './pages/currency-adjustment/currency-adjustments.component';
import { RolesComponent } from './pages/roles/roles.component';
import { CurrencyExchangeLogsComponent } from './pages/currency-exchange-log/currency-exchange-log.component';
import { BranchComponent } from './pages/branch/branch.component';
import { EmployeeDetailsComponent } from './pages/employee-details/employee-details.component';
import { LeaveApplyComponent } from './pages/employee-details/components/leaves/components/leave-apply/leave-apply.component';
import { LeaveManagementComponent } from './pages/leave-management/leave-management.component';
import { LeaveApprovalsComponent } from './pages/leave-approvals/leave-approvals.component';
import { VacationManagementComponent } from './pages/vacation-management/vacation-management.component';
import { VacationApplyComponent } from './pages/employee-details/components/vacation/components/vacation-apply/vacation-apply.component';
import { VacationApprovalsComponent } from './pages/vacation-approvals/vacation-approvals.component';
import { HolidayComponent } from './pages/holiday/holiday.component';
import { DesignationComponent } from './pages/designations/designations.component';
import { DepartmentComponent } from './pages/departments/departments.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ManualJournalsComponent } from './pages/manual-journals/manual-journals.component';
import { ManualJournalNewComponent } from './pages/manual-journal-new/manual-journal-new.component';
import { ChartAccountsComponent } from './pages/chart-accounts/chart-accounts.component';
import { ChartAccountsDetailsComponent } from './pages/chart-accounts-details/chart-accounts-details.component';
import { NewChartAccountComponent } from './pages/new-chart-account/new-chart-account.component';
import { ManualJournalDetailsComponent } from './pages/manual-journal-details/manual-journal-details.component';
import { ClientsComponent } from './pages/clients/clients.component';
import { ClientNewComponent } from './pages/client-new/client-new.component';
import { RolesManagementComponent } from './pages/roles-management/roles-management.component';
import {
  AddTaskComponent,
  TaskComponent,
} from './pages/task-management/tasks.component';
import { VendorsComponent } from './pages/vendor/vendors.component';
import { VendorNewComponent } from './pages/vendor-new/vendor-new.component';
import {
  AddServiceComponent,
  ServiceComponent,
} from './pages/service-management/services.component';
import { ClientDetailsComponent } from './pages/client-details/client-details.component';
import { VendorDetailsComponent } from './pages/vendor-details/vendor-details.component';
import { LeadsComponent } from './pages/leads/leads.component';
import { InvoiceComponent } from './pages/invoice/invoice.component';
import { QuotationComponent } from './pages/quotation/quotation.component';
import { QuotationDetailsComponent } from './pages/quotation-details/quotation-details.component';
import { QuotationNewComponent } from './pages/quotation-new/quotation-new.component';
import { SalesOrderComponent } from './pages/sales-order/sales-order.component';
import { SalesOrderDetailsComponent } from './pages/sales-order-details/sales-order-details.component';
import { ProjectsListComponent } from './pages/projects/projects.component';
import { ProjectNewComponent } from './pages/project-new/project-new.component';
import { LeadNewComponent } from './pages/lead-new/lead-new.component';
import { InvoiceNewComponent } from './pages/invoice-new/invoice-new.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { InvoiceDetailsComponent } from './pages/invoice-details/invoice-details.component';
import { VendorInvoiceComponent } from './pages/vendor-invoice/vendor-invoice.component';
import { VendorInvoiceNewComponent } from './pages/vendor-invoice-new/vendor-invoice-new.component';
import { VendorInvoiceDetailsComponent } from './pages/vendor-invoice-details/vendor-invoice-details.component';
import { ExpensesListComponent } from './pages/expenses/expenses.component';
import { ExpenseDetailsComponent } from './pages/expense-details/expense-details.component';
import { RefundComponent } from './pages/refund/refund.component';
import { RefundNewComponent } from './pages/refund-new/refund-new.component';
import { RefundDetailsComponent } from './pages/refund-details/refund-details.component';
import { BankingComponent } from './pages/banking/banking.component';
import { AddBankAccountComponent } from './pages/add-bank-account/add-bank-account.component';
import { OrderFlowAdminListComponent } from './pages/order-flow-admin-list/order-flow-admin-list.component';
import { OrderFlowAdminViewComponent } from './pages/order-flow-admin-view/order-flow-admin-view.component';
import { OrderFlowAssignedListComponent } from './pages/order-flow-assigned-list/order-flow-assigned-list.component';
import { OrderFlowAssignedViewComponent } from './pages/order-flow-assigned-view/order-flow-assigned-view.component';
import { BillPaymentNewComponent } from './pages/bill-payment-new/bill-payment-new.component';
import { PaymentsMadeComponent } from './pages/payments-made/payments-made.component';
import { PaymentReceivedComponent } from './pages/payment-received/payment-received.component';
import { PaymentNewComponent } from './pages/payment-new/payment-new.component';
import { PaymentsMadeDetailsComponent } from './pages/payments-made-details/payments-made-details.component';
import { PaymentReceivedDetailsComponent } from './pages/payment-received-details/payment-received-details.component';
import { PettyCashComponent } from './pages/petty-cash/petty-cash.component';
import { PettyCashDetails } from './pages/petty-cash-details/petty-cash-details.component';
import { AddPettyCashActivity } from './pages/petty-cash-activity/petty-cash-activity.component';
import { AttendanceManagementComponent } from './pages/attendance-management/attendance-management.component';
import { PayrollListComponent } from './pages/payroll-list/payroll-list.component';
import { PayrollComponent } from './pages/payroll/payroll.component';
import { PayrollIndividualComponent } from './pages/payroll-individual/payroll-individual.component';
import { PettyCashNewComponent } from './pages/petty-cash-new/petty-cash-new.component';
import { PurchaseOrderComponent } from './pages/purchase-order/purchase-order.component';
import { PurchaseOrderNewComponent } from './pages/purchase-order-new/purchase-order-new.component';
import { PurchaseOrderDetailsComponent } from './pages/purchase-order-details/purchase-order-details.component';
import { AccommodationComponent } from './pages/accommodation/accommodation.component';
import { AccommodationNewComponent } from './pages/accommodation-new/accommodation-new.component';
import { AccommodationDetailsComponent } from './pages/accommodation-details/accommodation-details.component';
import { ModuleIds } from './shared/permission-constants/permission-const';
import { AccommodationLogComponent } from './pages/accommodation-log/accommodation-log.component';
import { AccommodationMonthlyRentComponent } from './pages/accommodation-monthly-rent/accommodation-monthly-rent.component';
import { BankingDetailsComponent } from './pages/banking-details/banking-details.component';
import { StationaryItemsComponent } from './pages/stationary-items/stationary-items.component';
import { StationaryNewComponent } from './pages/stationary-new/stationary-new.component';
import { StationaryLogComponent } from './pages/stationary-log/stationary-log.component';
import { StationaryLogNewComponent } from './pages/stationary-log-new/stationary-log-new.component';
import { LogsListComponent } from './pages/logs-list/logs-list.component';
import { PurchaseDetailsComponent } from './pages/purchase-details/purchase-details.component';
import { PurchaseNewComponent } from './pages/purchase-new/purchase-new.component';
import { PurchaseComponent } from './pages/purchase/purchase.component';
import { SupplierNewComponent } from './pages/supplier-new/supplier-new.component';
import { SuppliersComponent } from './pages/suppliers/suppliers.component';
import { AddTemplateComponent, TemplateComponent } from './pages/notification-template/template.component';
import { ReportsComponent } from './pages/reports/reports.component';
import { NotificationComponent } from './pages/notification/notification.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, pathMatch: 'full' },
  {
    path: 'dashboard',
    component: DashboardComponent,
    data: { breadcrumb: 'Dashboard' },
    pathMatch: 'full'
    // canActivate: [AuthGuard],
  },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  {
    path: 'my-profile/:id',
    component: EmployeeDetailsComponent,
    data: { breadcrumb: 'My Profile' },
    canActivate: [AuthGuard],
  },
  {
    path: 'notifications',
    component: NotificationComponent,
    data: { breadcrumb: 'Notifications' },
    canActivate: [AuthGuard],
  },
  {
    path: 'employees',
    component: EmployeesComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Employees',
      allowedRoles: {
        moduleId: ModuleIds.Employee,
      },
    },
  },
  {
    path: 'employees/detail/:id',
    component: EmployeeDetailsComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Employee Details',
      allowedRoles: {
        moduleId: ModuleIds.Employee,
        permissionKeys: ['Details'],
      },
    },
  },
  {
    path: 'add-employee',
    component: AddEmployeeComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Add Employee',
      allowedRoles: {
        moduleId: ModuleIds.Employee,
        permissionKeys: ['Create'],
      },
    },
  },
  {
    path: 'employees/edit/:id',
    component: AddEmployeeComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: {
        moduleId: ModuleIds.Employee,
        permissionKeys: ['Edit'],
      },
    }
  },

  {
    path: 'attendance-management',
    component: AttendanceManagementComponent,
    data: {
      breadcrumb: 'Attendance',
      allowedRoles: {
        moduleId: ModuleIds.Attendance,
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'leaves',
    component: LeaveManagementComponent,
    data: {
      breadcrumb: 'Leave Management',
      allowedRoles: {
        moduleId: 3,
      },
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'leaves/apply-leave',
    component: LeaveApplyComponent,
    data: {
      breadcrumb: 'Leave Management',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'leaves/approvals/:id',
    component: LeaveApprovalsComponent,
    data: {
      breadcrumb: 'Leave Approvals',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'vacation-management',
    component: VacationManagementComponent,
    data: {
      breadcrumb: 'Vacation Management',
      allowedRoles: {
        moduleId: 5,
      },
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'vacation-management/apply-vacation',
    component: VacationApplyComponent,
    data: {
      breadcrumb: 'Vacation Management',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'vacation-management/vacation-approvals/:id',
    component: VacationApprovalsComponent,
    data: {
      breadcrumb: 'Vacation Approvals',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'holiday',
    component: HolidayComponent,
    data: {
      breadcrumb: 'Holiday',
      allowedRoles: {
        moduleId: 9,
      },
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'designations',
    component: DesignationComponent,
    data: {
      breadcrumb: 'Designations',
      allowedRoles: {
        moduleId: 10,
      },
    },
    canActivate: [AuthGuard],
  },

  {
    path: 'departments',
    component: DepartmentComponent,
    data: {
      breadcrumb: 'Departments',
      allowedRoles: {
        moduleId: 11,
      },
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'roles',
    component: RolesComponent,
    data: { breadcrumb: 'Roles' },
    canActivate: [AuthGuard],
  },
  {
    path: 'roles/roles-management/:id',
    component: RolesManagementComponent,
    data: {
      breadcrumb: 'Roles Management',
    },
    canActivate: [AuthGuard],
  },

  {
    path: 'payroll/payroll-list',
    component: PayrollListComponent,
    data: {
      breadcrumb: 'Payroll List',
    },
    canActivate: [AuthGuard],
  },
  // {
  //   path: 'payroll/fine-logs',
  //   component: FineLogComponent,
  //   data: {
  //     breadcrumb: 'Fine Logs',
  //   },
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'payroll',
    component: PayrollComponent,
    data: {
      breadcrumb: 'Payroll',
      allowedRoles: {
        moduleId: ModuleIds.Payroll,
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'payroll/payroll-process/:id',
    component: PayrollIndividualComponent,
    data: {
      breadcrumb: 'Payroll Process',
      allowedRoles: {
        moduleId: ModuleIds.Payroll,
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'currency-adjustments',
    component: CurrencyAdjustmentsComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Currency Adjustment',
      allowedRoles: {
        moduleId: ModuleIds.Currency,
      },
    },
  },
  {
    path: 'currency-adjustments/exchange-logs/:id',
    component: CurrencyExchangeLogsComponent,
    data: {
      breadcrumb: 'Exchange Logs',
    },
  },
  {
    path: 'branch',
    component: BranchComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Branches',
      allowedRoles: {
        moduleId: ModuleIds.Branch
      }
    },
  },
  {
    path: 'customers',
    component: ClientsComponent,
    data: {
      breadcrumb: 'Customers',
      allowedRoles: {
        moduleId: ModuleIds.Customers
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'customers/customer-new',
    component: ClientNewComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'customers/customer-edit/:id',
    component: ClientNewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'customers/customer-details',
    component: ClientDetailsComponent,
    data: {
      breadcrumb: 'Customer Details',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'chart-of-accounts',
    component: ChartAccountsComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Chart Of Accounts',
      allowedRoles: {
        moduleId: ModuleIds.ChartAccount,
      }
    },
  },
  {
    path: 'chart-of-accounts/chart-of-accounts-details/:id',
    component: ChartAccountsDetailsComponent,
    data: {
      breadcrumb: 'Chart Of Accounts Details',
    },
  },
  {
    path: 'chart-of-accounts/new-chart-of-accounts',
    component: NewChartAccountComponent,
    data: {
      breadcrumb: 'New Chart Of Accounts',
    },
  },
  {
    path: 'manual-journals',
    component: ManualJournalsComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Manual Journals',
      allowedRoles: {
        moduleId: ModuleIds.ManualJournal,
      }
    },
  },
  {
    path: 'manual-journals/add',
    component: ManualJournalNewComponent,
    data: {
      breadcrumb: 'New Manual Journal',
    },
  },
  {
    path: 'manual-journals/edit/:id',
    component: ManualJournalNewComponent,
    data: {
      breadcrumb: 'Manual Journal Edit',
    },
  },
  {
    path: 'manual-journals/detail/:id',
    component: ManualJournalDetailsComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Manual Journal Details',
      allowedRoles: {
        moduleId: ModuleIds.ManualJournal,
      }
    },
  },
  {
    path: 'tasks',
    component: TaskComponent,
    data: {
      breadcrumb: 'Tasks',
      allowedRoles: {
        moduleId: ModuleIds.TaskManagement
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'tasks/add-tasks',
    component: AddTaskComponent,
    data: {
      breadcrumb: 'Tasks',
      allowedRoles: {
        moduleId: ModuleIds.TaskManagement,
        permissionKeys: ['Create']
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'tasks/edit-task/:id',
    component: AddTaskComponent,
    data: {
      breadcrumb: 'Tasks',
      allowedRoles: {
        moduleId: ModuleIds.TaskManagement,
        permissionKeys: ['Edit']
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'vendors',
    component: VendorsComponent,
    data: {
      breadcrumb: 'Vendors',
      allowedRoles: {
        moduleId: ModuleIds.Vendor
      },
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'vendors/vendors-new',
    component: VendorNewComponent,
    data: {
      allowedRoles: {
        moduleId: ModuleIds.Vendor,
        permissionKeys: ['Create'],
      },
    },
    canActivate: [AuthGuard],
  },

  {
    path: 'vendors/vendors-edit/:id',
    component: VendorNewComponent,
    data: {
      allowedRoles: {
        moduleId: ModuleIds.Vendor,
        permissionKeys: ['Edit'],
      },
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'vendors/vendor-details',
    component: VendorDetailsComponent,
    data: {
      breadcrumb: 'Vendor Details',
      allowedRoles: {
        moduleId: ModuleIds.Vendor,
        permissionKeys: ['Details'],
      },
    },
    canActivate: [AuthGuard],
  },

  {
    path: 'services',
    component: ServiceComponent,
    data: {
      breadcrumb: 'Services',
      allowedRoles: {
        moduleId: ModuleIds.ServiceManagement,
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'services/add-services',
    component: AddServiceComponent,
    data: {
      breadcrumb: 'Services',
      allowedRoles: {
        moduleId: ModuleIds.ServiceManagement,
        permissionKeys: ['Create']
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'services/edit-services/:id',
    component: AddServiceComponent,
    data: {
      breadcrumb: 'Services',
      allowedRoles: {
        moduleId: ModuleIds.ServiceManagement,
        permissionKeys: ['Edit']
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'invoice',
    component: InvoiceComponent,
    data: {
      breadcrumb: 'Invoice',
      allowedRoles: {
        moduleId: ModuleIds.Invoice
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'invoice/invoice-new',
    component: InvoiceNewComponent,
    data: {
      breadcrumb: 'New Invoice',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'invoice/invoice-edit/:id',
    component: InvoiceNewComponent,
    data: {
      breadcrumb: 'New Invoice',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'invoice/invoice-details',
    component: InvoiceDetailsComponent,
    data: {
      breadcrumb: 'Invoice Details',
      allowedRoles: {
        moduleId: ModuleIds.Invoice
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'leads',
    component: LeadsComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Leads',
      allowedRoles: {
        moduleId: ModuleIds.Leads,
      },
    },
  },
  {
    path: 'quotation/quotation-new',
    component: QuotationNewComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'quotation/quotation-edit/:id',
    component: QuotationNewComponent,
    data: {
      breadcrumb: 'New Quotation',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'quotation/quotation-details',
    component: QuotationDetailsComponent,
    data: {
      breadcrumb: 'Quotation Details',
      allowedRoles: {
        moduleId: ModuleIds.Quotation
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'quotation',
    component: QuotationComponent,
    data: {
      breadcrumb: 'Quotation',
      allowedRoles: {
        moduleId: ModuleIds.Quotation,
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'sales-order',
    component: SalesOrderComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Sales Order',
      allowedRoles: {
        moduleId: ModuleIds.SalesOrder
      }
    },
  },
  {
    path: 'sales-order/sales-order-details',
    component: SalesOrderDetailsComponent,
    data: {
      breadcrumb: 'Sales Order Details',
    },
  },
  {
    path: 'projects',
    component: ProjectsListComponent,
    data: {
      breadcrumb: 'Project',
    },
  },
  {
    path: 'projects/project-edit/:id',
    component: ProjectNewComponent,
    data: {
      breadcrumb: 'Project Edit',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'leads/add',
    component: LeadNewComponent,
    data: {
      breadcrumb: 'Leads Add',
    },
  },
  {
    path: 'leads/edit/:id',
    component: LeadNewComponent,
    data: {
      breadcrumb: 'Leads Edit',
    },
  },
  {
    path: 'vendor-invoice',
    component: VendorInvoiceComponent,
    data: {
      breadcrumb: 'Vendor Invoice',
      allowedRoles: {
        moduleId: ModuleIds.VendorInvoice,
      },
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'vendor-invoice/vendor-invoice-new',
    component: VendorInvoiceNewComponent,
    data: {
      breadcrumb: 'New Vendor Invoice',
      allowedRoles: {
        moduleId: ModuleIds.VendorInvoice,
        permissionKeys: ['Create'],
      },
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'vendor-invoice/vendor-invoice-edit/:id',
    component: VendorInvoiceNewComponent,
    data: {
      breadcrumb: 'Edit Vendor Invoice',
      allowedRoles: {
        moduleId: ModuleIds.VendorInvoice,
        permissionKeys: ['Edit'],
      },
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'vendor-invoice/vendor-invoice-details',
    component: VendorInvoiceDetailsComponent,
    data: {
      breadcrumb: 'Vendor Invoice Details',
      allowedRoles: {
        moduleId: ModuleIds.VendorInvoice
      },
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'expenses',
    component: ExpensesListComponent,
    data: {
      breadcrumb: 'Expenses',
      allowedRoles: {
        moduleId: ModuleIds.Expenses
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'expenses/details/:id',
    component: ExpenseDetailsComponent,
    data: {
      breadcrumb: 'Expense Details',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'refund',
    component: RefundComponent,
    data: {
      breadcrumb: 'Refund',
    },
  },
  {
    path: 'refund/refund-new',
    component: RefundNewComponent,
    data: {
      breadcrumb: 'New Refund',
    },
  },
  {
    path: 'refund/refund-edit/:id',
    component: RefundNewComponent,
    data: {
      breadcrumb: 'New Refund',
    },
  },
  {
    path: 'refund/refund-details',
    component: RefundDetailsComponent,
    data: {
      breadcrumb: 'Refund Details',
    },
  },
  {
    path: 'order-flow-admin-list',
    component: OrderFlowAdminListComponent,
  },
  {
    path: 'sales-order/order-flow-admin-view',
    component: OrderFlowAdminViewComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: {
        moduleId: ModuleIds.SalesOrder
      }
    }
  },
  {
    path: 'order-flow-assigned-list',
    component: OrderFlowAssignedListComponent,
  },
  {
    path: 'order-flow-assigned-list/order-flow-assigned-view',
    component: OrderFlowAssignedViewComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRoles: {
        moduleId: ModuleIds.OrderFlow
      }
    }
  },
  {
    path: 'banking',
    component: BankingComponent,
    canActivate : [AuthGuard],
    data: {
      breadcrumb: 'Banking',
      allowedRoles: {
        moduleId: ModuleIds.Banking
      }
    },
  },
  {
    path: 'banking/add-bank-account',
    component: AddBankAccountComponent,
    data: {
      breadcrumb: 'Banking',
    },
  },
  {
    path: 'banking/edit-bank-account/:id',
    component: AddBankAccountComponent,
    data: {
      breadcrumb: 'Banking',
    },
  },
  {
    path: 'banking/edit-credit-card/:id',
    component: AddBankAccountComponent,
    data: {
      breadcrumb: 'Banking',
    },
  },
  {
    path: 'payment-received',
    component: PaymentReceivedComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Payment Received',
      allowedRoles: {
        moduleId: ModuleIds.PaymentReceived
      }
    }
  },
  {
    path: 'payment-received/payment-new',
    component: PaymentNewComponent,
    data: {
      breadcrumb: 'New Payment',
    }
  },
  {
    path: 'payment-received/update-payment/:id',
    component: PaymentNewComponent,
    data: {
      breadcrumb: 'New Payment',
    }
  },
  {
    path: 'payment-received/payment-received-details',
    component: PaymentReceivedDetailsComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Payment Received Details',
      allowedRoles: {
        moduleId: ModuleIds.PaymentReceived
      }
    }
  },
  {
    path: 'payments-made',
    component: PaymentsMadeComponent,
    data: {
      breadcrumb: 'Payments Made',
      allowedRoles: {
        moduleId: ModuleIds.PaymentMade
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'payments-made/bill-payment-new',
    component: BillPaymentNewComponent,
    data: {
      breadcrumb: 'New Bill Payment',
      allowedRoles: {
        moduleId: ModuleIds.PaymentMade,
        permissionKeys: ['Create']
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'payments-made/update-bill-payment/:id',
    component: BillPaymentNewComponent,
    data: {
      breadcrumb: 'Update Bill Payment',
      allowedRoles: {
        moduleId: ModuleIds.PaymentMade,
        permissionKeys: ['Edit']
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'payments-made/payments-made-details',
    component: PaymentsMadeDetailsComponent,
    data: {
      breadcrumb: 'Payments Made Details',
      allowedRoles: {
        moduleId: ModuleIds.PaymentMade
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'petty-cash',
    component: PettyCashComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Petty Cash',
      allowedRoles: {
        moduleId: ModuleIds.PettyCash
      }
    }
  },
  {
    path: 'petty-cash/petty-cash-details',
    component: PettyCashDetails,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Petty Cash Details',
      allowedRoles: {
        moduleId: ModuleIds.PettyCash
      }
    }
  },
  {
    path: 'petty-cash/petty-cash-activity',
    component: AddPettyCashActivity,
    data: {
      breadcrumb: 'Petty Cash Activity',
    }
  },
  {
    path: 'petty-cash/add-petty-cash',
    component: PettyCashNewComponent,
    data: {
      breadcrumb: 'Add Petty Cash',
    }
  },
  
  {
    path: 'purchase-order',
    component: PurchaseOrderComponent,
    data: {
      breadcrumb: 'Purchase Order',
      allowedRoles: {
        moduleId: ModuleIds.PurchaseOrder
      },
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'purchase-order/purchase-order-new',
    component: PurchaseOrderNewComponent,
    data: {
      breadcrumb: 'New Purchase Order',
      allowedRoles: {
        moduleId: ModuleIds.PurchaseOrder,
        permissionKeys: ['Create'],
      },
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'purchase-order/purchase-order-edit/:id',
    component: PurchaseOrderNewComponent,
    data: {
      breadcrumb: 'Edit Purchase Order',
      allowedRoles: {
        moduleId: ModuleIds.PurchaseOrder,
        permissionKeys: ['Edit'],
      },
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'purchase-order/purchase-order-details',
    component: PurchaseOrderDetailsComponent,
    data: {
      breadcrumb: 'Purchase Order Details',
      allowedRoles: {
        moduleId: ModuleIds.PurchaseOrder
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'accommodation',
    component: AccommodationComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Accommodations',
      allowedRoles: {
        moduleId: ModuleIds.Accommodation,
      },
    },
  },
  {
    path: 'accommodation/new',
    component: AccommodationNewComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'New Accommodations',
      allowedRoles: {
        moduleId: ModuleIds.Accommodation,
      },
    },
  },
  {
    path: 'accommodation/edit/:id',
    component: AccommodationNewComponent,
    data: {
      breadcrumb: 'New Accommodations',
    }
  },
  {
    path: 'accommodation/detail',
    component: AccommodationDetailsComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Accommodation Details',
      allowedRoles: {
        moduleId: ModuleIds.Accommodation,
      },
    }
  },
  {
    path: 'accommodation/accommodation-log',
    component: AccommodationLogComponent,
    data: {
      breadcrumb: 'Accommodation Details',
    }
  },
  {
    path: 'accommodation/monthly-rent',
    component: AccommodationMonthlyRentComponent,
    data: {
      breadcrumb: 'Accommodation Details',
    }
  },
  {
    path: 'banking/banking-details/:id',
    component: BankingDetailsComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Banking Details',
      allowedRoles: {
        moduleId: ModuleIds.Banking,
      }
    }
  },
  {
    path: 'stationary-items',
    component: StationaryItemsComponent,
    data: {
      breadcrumb: 'Stationary Items',
      allowedRoles: {
        moduleId: ModuleIds.StationaryItems
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'stationary-items/stationary-new',
    component: StationaryNewComponent,
    data: {
      breadcrumb: 'New Supplier',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'stationary-items/stationary-edit/:id',
    component: StationaryNewComponent,
    data: {
      breadcrumb: 'New Supplier',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'stationary-log',
    component: StationaryLogComponent,
    data: {
      breadcrumb: 'Stationary Log',
      allowedRoles: {
        moduleId: ModuleIds.StationaryLog
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'stationary-log/new-stationary-log',
    component: StationaryLogNewComponent,
    data: {
      breadcrumb: 'Stationary Log',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'stationary-items/expense-logs/:id',
    component: LogsListComponent,
    data: { 
      breadcrumb: 'Expense Logs',
      allowedRoles: {
        moduleId: ModuleIds.StationaryItems
      }
     },
    canActivate: [AuthGuard],
  },

  {
    path: 'daily-purchase',
    component: PurchaseComponent,
    data: {
      breadcrumb: 'Daily Purchase',
      allowedRoles: {
        moduleId: ModuleIds.DailyPurchase
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'daily-purchase/purchase-details/:id',
    component: PurchaseDetailsComponent,
    data: {
      breadcrumb: 'Purchase Details',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'daily-purchase/purchase-new',
    component: PurchaseNewComponent,
    data: {
      breadcrumb: 'New Purchase',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'daily-purchase/purchase-edit/:id',
    component: PurchaseNewComponent,
    data: {
      breadcrumb: 'New Purchase',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'suppliers',
    component: SuppliersComponent,
    data: {
      breadcrumb: 'Suppliers',
      allowedRoles: {
        moduleId: ModuleIds.Suppliers
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'suppliers/supplier-new',
    component: SupplierNewComponent,
    data: {
      breadcrumb: 'New Supplier',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'suppliers/supplier-edit/:id',
    component: SupplierNewComponent,
    data: {
      breadcrumb: 'New Supplier',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'notification-template',
    component: TemplateComponent,
    data: {
      breadcrumb: 'Notification Template',
      allowedRoles: {
        moduleId: ModuleIds.NotificationTemplate
      }
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'notification-template/add-template',
    component: AddTemplateComponent,
    data: {
      breadcrumb: 'Notification Template',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'notification-template/edit-template/:id',
    component: AddTemplateComponent,
    data: {
      breadcrumb: 'Notification Template',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'reports',
    component: ReportsComponent,
    data: {
      breadcrumb: 'Reports',
      allowedRoles: {
        moduleId: ModuleIds.Reports
      }
    },
    canActivate: [AuthGuard],
  },
  { path: '**', redirectTo: 'page-not-found' },
];

export const appRouterConfig = provideRouter(
  routes,
  withRouterConfig({
    onSameUrlNavigation: 'reload',
  })
);
